import React, { memo } from 'react'
import { CellValue, IdType } from 'react-table'
import { HomeLog } from '@racepointenergy/swc/scs/types'
import { useIntl } from 'react-intl'

import theme from 'theme_'
import { Body12, BodyPrimary } from 'components/Typography/Labels'
import IntlFormattedDate from 'app/i18n/IntlFormattedDate'
import {
  MobileTableBlock,
  MobileTableBlockCell,
  MobileTableBlockHeader,
  MobileTableBlockRow,
} from 'components/Table/MobileBlock/styles'
import { homeLogsTableMessages } from '../../messages'
import { HOME_LOGS_HEADERS } from '../../consts'
import { ActionsCell } from '../index'

interface HomeLogsMobileBlockProps {
  original: HomeLog
  values: Record<IdType<HomeLog>, CellValue>
}

export function HomeLogsMobileBlock({
  values,
  original,
}: HomeLogsMobileBlockProps) {
  const { formatMessage } = useIntl()

  return (
    <MobileTableBlock>
      <MobileTableBlockRow>
        <MobileTableBlockHeader>
          <BodyPrimary bold color={theme.colors.otterWarmBlack}>
            <strong>{values[HOME_LOGS_HEADERS.PROCESS_NAME]}</strong>
          </BodyPrimary>
        </MobileTableBlockHeader>
        <ActionsCell log={original} />
      </MobileTableBlockRow>

      <MobileTableBlockRow>
        <MobileTableBlockCell>
          <Body12 color={theme.colors.darkeyGrey}>
            {formatMessage(homeLogsTableMessages.uid)}
          </Body12>
        </MobileTableBlockCell>
        <MobileTableBlockCell>
          <BodyPrimary color={theme.colors.otterWarmBlack}>
            {values[HOME_LOGS_HEADERS.UID]}
          </BodyPrimary>
        </MobileTableBlockCell>
      </MobileTableBlockRow>

      <MobileTableBlockRow>
        <MobileTableBlockCell>
          <Body12 color={theme.colors.darkeyGrey}>
            {formatMessage(homeLogsTableMessages.softwareVersion)}
          </Body12>
        </MobileTableBlockCell>
        <MobileTableBlockCell>
          <BodyPrimary color={theme.colors.otterWarmBlack}>
            {values[HOME_LOGS_HEADERS.SOFTWARE_VERSION]}
          </BodyPrimary>
        </MobileTableBlockCell>
      </MobileTableBlockRow>

      <MobileTableBlockRow>
        <MobileTableBlockCell>
          <Body12 color={theme.colors.darkeyGrey}>
            {formatMessage(homeLogsTableMessages.uploadTime)}
          </Body12>
        </MobileTableBlockCell>
        <MobileTableBlockCell>
          <BodyPrimary color={theme.colors.otterWarmBlack}>
            <IntlFormattedDate
              date={values[HOME_LOGS_HEADERS.UPLOAD_TIME]}
              withTime
            />
          </BodyPrimary>
        </MobileTableBlockCell>
      </MobileTableBlockRow>
    </MobileTableBlock>
  )
}

export default memo(HomeLogsMobileBlock)
